import React, { useContext } from "react";
import { Autocomplete, TextField } from "@mui/material";
import GroupBiorepositoryOps from "../FieldTags/GroupBiorepositoryOps";
import { UserContext } from "../../context/UserContext";
import pullListLabels from "../../util/PullListLabels";
import ROLES from "../../util/roles";
import HistoryLogElement from "./HistoryLogElement";
import { checkRole } from "../../util/FormUtils";

const Courier = ({ courier, handleChange, pullLists, couriers, informedConsent, informedConsentApprover, required }) => {
    const { user } = useContext(UserContext);
    const canEdit = informedConsent !== "No" && informedConsentApprover !== "No" && checkRole(user, [ROLES.BIOOPS, ROLES.APPROVER, ROLES.DCT]);

    return (
        <div className="planField">
            <GroupBiorepositoryOps />
            <Autocomplete
                name="courier"
                autoHighlight
                options={couriers}
                value={courier ? courier : ""}
                onChange={(_, newValue) => handleChange("courier", newValue)}
                renderInput={(params) =>
                    <TextField
                        {...params}
                        label={pullListLabels.courier}
                        InputLabelProps={{
                            shrink: true,
                            required: required,
                        }}
                        required={required}
                    />
                }
                disabled={!canEdit}
            />
            <HistoryLogElement pullLists={pullLists} label={"courier"} />
        </div>
    );
};

export default Courier;